export default function PaginationMenu({ children, limit, setLimit, count, loading }) {
  
  if (!loading)
    return (
      <div className="flex items-center justify-between text-sm text-stone-200">
        <p className="text-stone-400">
          Showing: <span className="text-stone-200">{count}</span> Records
        </p>
        <div className="items-center justify-around hidden space-x-4 lg:flex">{children}</div>
        <div className="flex items-center space-x-4">
          <p className="text-stone-400">Records Limit:</p>
          <select
            className="cursor-pointer input"
            value={limit}
            onChange={(e) => setLimit(e.target.value ?? false)}
          >
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="100">100</option>
            <option value="">All</option>
          </select>
        </div>
      </div>
    );
}
